const CountryCodedata = ["UK", "BE", "FR", "ES", "DE"];

export default CountryCodedata;
